import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CorporateService } from '../corporate-service/corporate-service';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { th } from 'date-fns/locale';
import { combinedReasons } from 'src/app/utils/utils.common';

@Component({
  selector: "app-corporate-cancel-reason",
  templateUrl: "./corporate-cancel-reason.component.html",
  styleUrls: ["./corporate-cancel-reason.component.css"],
})
export class CorporateCancelReasonComponent implements OnInit {
  cancelReasonForm: FormGroup;
  fundingSourceList = [];
  status = "active";
  submitted = false;
  levelOfServices = [];
  spaceTypesList = [];
  configurationsId;
  reasons = combinedReasons;
  selectedReason;
  filteredFundingSourceList = [];

  constructor(
    private fb: FormBuilder,
    private corporateService: CorporateService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    if (
      this.activatedRoute.snapshot.url.length === 5 &&
      this.activatedRoute.snapshot.url[4].path === "edit"
    ) {
      this.configurationsId = this.activatedRoute.snapshot.url[3].path;
    }

    this.cancelReasonForm = this.fb.group({
      cooperate: ["", Validators.required],
      reasons: [[], Validators.required],
    });

    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [this.getCorporateUsers()];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2]) => {
        if (res1) {
          this.fundingSourceList = res1;
          this.filteredFundingSourceList = this.fundingSourceList;
          this.getReasons();
        }

        if (res2) {
          this.spaceTypesList = res2;
        }
      },
      (error) => {
        sweetAlert("Error", error, "error", "OK");
      }
    );
  }

  getCorporateUsers() {
    return this.corporateService.getCorporateUsers(this.status);
  }

  getReasonById() {
    this.corporateService
      .getChangeReasonById(this.configurationsId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.filteredFundingSourceList = this.fundingSourceList.filter(u1 => data.cooperate === u1._id);
            this.cancelReasonForm.patchValue({
              cooperate: data.cooperate,
              reasons : data.reasons || [],
            });
          }
        },
        (err) => {
          sweetAlert("Error", err, "warning", "OK");
        }
      );
  }

  get form() {
    return this.cancelReasonForm.controls;
  }


  getReasons() {
    this.corporateService
      .getChangeReason()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          const mappers = data.map(item => {
            return item.cooperate
          });
          if (this.configurationsId) {
            this.getReasonById();
          } else {
            this.filteredFundingSourceList = this.fundingSourceList.filter(u1 =>
              !mappers.some(_id => u1._id === _id)
            );
          }
        }
      });
  }


  onSubmit() {
    this.submitted = true;
    if (this.cancelReasonForm.invalid) {
      return;
    }

    const payload = this.cancelReasonForm.value;
    this.corporateService
      .addCancelReason(payload, this.configurationsId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigate(["/credentialing/fundingsource"], {
              state: { isChangeReason: true },
            });
          }
        },
        (err) => {
          sweetAlert("Error", err, "warning", "OK");
        }
      );
  }

  ngOnDestroy(): void {}
}
